<div class="severity-cell">
  @if ($safeNavigationMigration(params()?.value) !== undefined && $safeNavigationMigration(params()?.value) !== null) {
    <iot-platform-ui-event-severity-display [severity]="$safeNavigationMigration(params()?.value)" />
  }
</div>
